import Env from '@lib/Env';

import { Actor } from '@types';

export const portfolioModelStates = {
    created: 'created',
    processing: 'processing',
    ready: 'ready',
    error: 'error',
};

export class PortfolioModel implements Actor.Portfolio {
    id: number = null;
    state: string = '';
    file_type: string = '';
    file_mime: string = '';
    file_id: string = '';
    file_name: string = '';
    nazov: string = '';
    poradie: number = null;
    processed_at: string = null;

    constructor({
        id,
        state,
        file_type,
        file_mime,
        file_id,
        file_name,
        nazov,
        poradie,
        processed_at,
    }: Actor.Portfolio) {
        this.id = id;
        this.state = state;
        this.file_type = file_type;
        this.file_mime = file_mime;
        this.file_id = file_id;
        this.file_name = file_name;
        this.nazov = nazov;
        this.poradie = poradie;
        this.processed_at = processed_at;
    }

    get url() {
        return `${Env.services.storage.baseURL}/${this.file_id}`;
    }

    set url(value) {
        //Noop
    }

    isConverted() {}
}
